import { Center, Flex, Image } from "@chakra-ui/react";
import React from "react";
import leftFire from "../assets/images/left_fire.svg";
import rightFire from "../assets/images/right_fire.svg";
import chairCat from "../assets/images/chair_cat.svg";
import manifestText from "../assets/images/manifest_text.svg";
import CustomText from "./CustomText";

const Manifesto = () => {
  return (
    <section id="manifesto">
      <Center
        flexDirection={"column"}
        mt={"-40px"}
        pb={"120px"}
        display={{ base: "flex", lg: "none" }}
      >
        <Image src={manifestText} alt="text" w={"150px"} ml={"-120px"} />
        <Image
          src={chairCat}
          alt="rightFire"
          zIndex={"-1"}
          w={"200px"}
          mb={"30px"}
        />
        <Center textAlign={"center"} px="20px" flexDirection="column">
          <CustomText
            size={{ base: "20px", lg: "36px" }}
            height={{ base: "24px", lg: "40.97px" }}
            text="Whether it's a bull run or a bear market, Furry Silence remains unflappable. That’s our edge—staying f*cking calm while the chaos becomes our playground."
            align="center"
          />
          <CustomText
            size={{ base: "20px", lg: "36px" }}
            height={{ base: "24px", lg: "40.97px" }}
            text="Learn More"
            align="center"
            decoration="underline"
          />
        </Center>
      </Center>
      <Flex
        color={"#191919"}
        align={"center"}
        justify={"space-between"}
        w={"100%"}
        mt={"-90px"}
        display={{ base: "none", lg: "flex" }}
      >
        <Flex justify={"flex-start"} position={"relative"}>
          <Image src={leftFire} alt="leftFire" />
        </Flex>
        <Flex
          maxW={"44%"}
          ml={"-320px"}
          mt={"-50px"}
          flexDir="column"
          align="center"
          // gap="10px"
        >
          <CustomText
            size="36px"
            height="40.97px"
            text="Whether it's a bull run or a bear market, Furry Silence remains unflappable."
            align="center"
          />
          <CustomText
            size="36px"
            height="40.97px"
            text="That’s our edge—staying f*cking calm while the chaos becomes our playground."
            align="center"
          />
          <CustomText
            size="36px"
            height="40.97px"
            text="Learn More"
            decoration="underline"
            cursor="pointer"
          />
        </Flex>
        <Flex align={"flex-start"} justify={"flex-end"} position={"relative"}>
          <Image
            src={manifestText}
            alt="text"
            position={"absolute"}
            right={464}
            bottom={530}
          />
          <Image src={rightFire} alt="rightFire" zIndex={"-1"} />
        </Flex>
      </Flex>
    </section>
  );
};

export default Manifesto;
